/*
    Autohandler for promo info tracking
 */

const $ = require('./../sw-jquery');
const ProductTracking = require('js/lib/tracking/product-tracking').ProductTracking;
const sw = require('js/lib/sw');

$(function () {
    $('body').on('click', '.product-info' , function (e) {
        let position = $(e.currentTarget).find('.product-name a').data('impressionPosition');
        const spin = $(this).data('spin');
        const productTracking = ProductTracking(spin, 'ProductInfo');
        productTracking.trackProductClick({location: sw.data.pageIdentifier, position: position});
    });
});
